<div class="grid">
	<div *ngFor="let in of counter(); let i = index;" class="col-12">
		<app-bet-input
			[betKey]="i+1"
			[(value)]="bets[i]"
			/>
	</div>
</div>
